<template>
    <main>
        <div v-if="showTrialExpired" data-test-id="trial-expired">
            <l-trial-expired />
        </div>
        <div v-else class="container-fluid container-full" data-test-id="main">
            <slot />
        </div>
    </main>
</template>

<script>
import { mapGetters } from "vuex";

import LTrialExpired from "@/components/LTrialExpired";

export default {
    components: {
        LTrialExpired,
    },
    data() {
        return {
            showTrialExpired: false,
        };
    },
    computed: {
        ...mapGetters({
            trialExpired: "users/current/trialExpired",
        }),
    },
    watch: {
        $route: {
            handler(route) {
                const isBillingScreen = route?.path === "/team/settings/billing";

                this.showTrialExpired = this.trialExpired && !isBillingScreen;
            },
        },
    },
};
</script>

<style scoped></style>
